import { Navigate } from 'react-router-dom';
import GuestGuard from '../presentation/GuestGuard';
import { LoginPage, AwsCognitoCallbackPage } from './elements';

const IdentityAndAccessRoutes = [
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        element: (
          <GuestGuard>
            <LoginPage />
          </GuestGuard>
        ),
      },
      {
        path: 'cognito-callback',
        element: (
          <GuestGuard>
            <AwsCognitoCallbackPage />
          </GuestGuard>
        ),
      },
    ],
  },
  { path: '*', element: <Navigate to="/404" replace /> },
];

export default IdentityAndAccessRoutes;
